import React from 'react';
import { motion } from 'framer-motion';

export default function Founder() {
  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center"
          data-testid="founder-section"
        >
          {/* Headshot */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            className="mb-6"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_trade-coach-10/artifacts/plc96iux_SINU%20DP.png"
              alt="Sinu Sivakumar - Founder & CEO"
              className="w-32 h-32 md:w-40 md:h-40 rounded-full mx-auto object-cover border-4 border-[#337AF7]/20 shadow-lg"
              data-testid="founder-photo"
            />
          </motion.div>

          {/* Name & Title */}
          <h3 
            className="text-2xl md:text-3xl font-bold text-[#162959] mb-1"
            data-testid="founder-name"
          >
            Sinu Sivakumar
          </h3>
          <p className="text-[#337AF7] font-semibold mb-6">
            Founder & CEO
          </p>

          {/* Quote */}
          <blockquote className="relative">
            <span className="absolute -top-4 -left-2 text-6xl text-[#337AF7]/10 font-serif">"</span>
            <p 
              className="text-lg md:text-xl text-[#162959]/80 leading-relaxed italic px-4 md:px-8"
              data-testid="founder-quote"
            >
              I built MYEAI Trading Compass because I was tired of seeing traders fail not from lack of skill, 
              but from lack of system. This isn't about signals. It's about building the discipline, 
              clarity, and community that turns trading into a sustainable career.
            </p>
            <span className="absolute -bottom-8 -right-2 text-6xl text-[#337AF7]/10 font-serif">"</span>
          </blockquote>

          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="mt-10 text-lg font-semibold text-[#337AF7]"
            data-testid="founder-tagline"
          >
            Passion. Purpose. People.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}
